export const SUCCESS_DEFAULT = 'SUCCESS_DEFAULT';
export const FAILURE_DEFAULT = 'FAILURE_DEFAULT';
export const LOAD_ACTIVITYCOMPONENT = 'LOAD_ACTIVITYCOMPONENT';
export const UPDATE_ACTIVITYCOMPONENT = 'UPDATE_ACTIVITYCOMPONENT';
export const UPDATE_ORDCNFMSG = 'UPDATE_ORDCNFMSG';
export const ClOSE_DEALCNFMSG = 'ClOSE_DEALCNFMSG';
export const ClOSE_BMKCNFMSG = 'ClOSE_BMKCNFMSG';
export const RESET_STATE = 'RESET_STATE';
export const CLOSE_BM_MODAL = 'CLOSE_BM_MODAL'
export const ADD_ACTIVITYCOMPONENT = 'ADD_ACTIVITYCOMPONENT';
//export const REFRESH_PROXIMITY='REFRESH_PROXIMITY';
export const REFRESH_PROXIMITY1 = 'REFRESH_PROXIMITY1';
export const CLOSE_REQ_REJECTED_MODAL = 'CLOSE_REQ_REJECTED_MODAL';
export const GET_ALL_ORDER_DATA = 'GET_ALL_ORDER_DATA';
export const GET_ALL_ORDER_DATA_SUCCESS = 'GET_ALL_ORDER_DATA_SUCCESS';
export const GET_ALL_ORDER_DATA_FAILURE = 'GET_ALL_ORDER_DATA_FAILURE';
export const GET_BENCHMARK_ORDER_DATA = 'GET_BENCHMARK_ORDER_DATA';
export const GET_BENCHMARK_ORDER_DATA_SUCCESS = 'GET_BENCHMARK_ORDER_DATA_SUCCESS';
export const GET_BENCHMARK_ORDER_DATA_FAILURE = 'GET_BENCHMARK_ORDER_DATA_FAILURE';
export const GET_ORDERS_CTID = 'GET_ORDERS_CTID';
export const GET_TRADE_CTID = 'GET_TRADE_CTID';
export const DEAL_FAILED_FLAG = 'DEAL_FAILED_FLAG';
export const CLEAR_NOTIFICATION_FLAG = 'CLEAR_NOTIFICATION_FLAG';
export const SET_NOTIFICATION_COUNTER = 'SET_NOTIFICATION_COUNTER';
export const UPDATE_ACTIVITYDATA = 'UPDATE_ACTIVITYDATA';
export const CLOSE_PAY_REQ_REJECTED_MODAL = "CLOSE_PAY_REQ_REJECTED_MODAL";
export const BM_FAILED_FLAG = 'BM_FAILED_FLAG';
export const SET_LMT_ORD_FLAG = 'SET_LMT_ORD_FLAG';
export const SET_BMK_ORD_FLAG = 'SET_BMK_ORD_FLAG';
export const SET_STOP_ORD_FLAG = 'SET_STOP_ORD_FLAG';
export const RESET_ACTIVITY_STATE = 'RESET_ACTIVITY_STATE'
export const UPDATE_ORD_BMK_MRK = 'UPDATE_ORD_BMK_MRK';
export const UPDATE_ORD_MRK = 'UPDATE_ORD_MRK';
export const UPDATE_AVG_BMK = 'UPDATE_AVG_BMK';
export const RESET_IS_AVG_BMK_UPDATED = 'RESET_IS_AVG_BMK_UPDATED';
export const GET_AVG_BMK_DRILLDOWN_DATA = 'GET_AVG_BMK_DRILLDOWN_DATA';
export const GET_AVG_BMK_DRILLDOWN_DATA_SUCCESS = 'GET_AVG_BMK_DRILLDOWN_DATA_SUCCESS';
export const GET_AVG_BMK_DRILLDOWN_DATA_FAILURE = 'GET_AVG_BMK_DRILLDOWN_DATA_FAILURE';
export const DISPLAY_MODAL = 'DISPLAY_MODAL';
export const SELECT_ORDERS_ALL = 'SELECT_ORDERS_ALL';
export const NO_ORD_SELECTED = 'NO_ORD_SELECTED';
export const UPDATE_VD = 'UPDATE_VD';
export const LS_NOTIFICATION_CONN = "LS_NOTIFICATION_CONN";
export const CLOSE_LS_NOTIFICATION_CONN = "CLOSE_LS_NOTIFICATION_CONN";